export default __webpack_public_path__ + "static/media/feeling-center-illustration.41f75000.png";